import(/* webpackMode: "eager" */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/apps/pgs/src/app/register/page.tsx");
